import { css, type LitElement } from "lit";

import { ApiConsumer } from "#app/mixins/api-consumer.ts";
import { WithGlobalStylesheet } from "#app/mixins/with-global-stylesheet.ts";

type Constructor<T = unknown> = new (
  // biome-ignore lint/suspicious/noExplicitAny: using `unknown` triggers TS2545, see <https://github.com/microsoft/TypeScript/issues/37142>
  ...args: any[]
) => T;

export const TvrnView = <T extends Constructor<LitElement>>(el: T) =>
  ApiConsumer(
    WithGlobalStylesheet(
      class extends el {
        static styles = [
          (el as unknown as typeof LitElement).styles ?? [],
          css`
            :host {
              height: 100dvh;

              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              overflow: auto;

              background-color: var(--color-md-surface);
              color: var(--color-md-on-surface);
              font-family: var(--font-sans);
            }
          `,
        ];
      } as T,
    ),
  );
